import { render, staticRenderFns } from "./SequenceResults.vue?vue&type=template&id=13179f0b&"
import script from "./SequenceResults.vue?vue&type=script&lang=js&"
export * from "./SequenceResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports